import React from 'react';
import wb0 from '../img/Detail/acheinsecret_detail.jpg';
import './Detail.css';
const AcheInSecretDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default AcheInSecretDetail;